(function () {
  function cleanPhone(value) {
    return String(value || '').replace(/[^0-9]/g, '');
  }

  function visible(element) {
    return element && !element.hidden;
  }

  function setFieldError(form, name, message) {
    const field = form.querySelector('[name="' + name + '"]');
    const error = form.querySelector('[data-error-for="' + name + '"]');
    if (field) {
      field.classList.toggle('is-invalid', Boolean(message));
      field.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (error) {
        const errorId = 'ss-error-' + name;
        error.id = errorId;
        field.setAttribute('aria-describedby', errorId);
      }
    }
    if (error) error.textContent = message || '';
  }

  function getValue(form, name) {
    const field = form.querySelector('[name="' + name + '"]');
    return field ? field.value.trim() : '';
  }

  function updateService(root, service, shouldFocus) {
    const form = root.querySelector('[data-ss-form]');
    if (!form) return;

    const serviceField = form.querySelector('[name="service"]');
    if (serviceField && service) serviceField.value = service;
    const activeService = serviceField ? serviceField.value : 'india-shopping';

    root.querySelectorAll('[data-service-fields]').forEach((group) => {
      const isActive = group.getAttribute('data-service-fields') === activeService;
      group.hidden = !isActive;
      group.querySelectorAll('input, textarea, select').forEach((field) => {
        if (!isActive) {
          field.removeAttribute('required');
          field.classList.remove('is-invalid');
        } else if (field.name === 'destination_india_shopping' || field.name === 'destination_student_care') {
          field.setAttribute('required', 'required');
        }
      });
    });

    root.querySelectorAll('[data-service-card]').forEach((card) => {
      card.classList.toggle('is-selected', card.getAttribute('data-service-card') === activeService);
    });

    if (shouldFocus) {
      const target = form.querySelector('[name="' + (activeService === 'student-care' ? 'pickup' : 'orders') + '"]') || form.querySelector('[name="name"]');
      if (target) window.setTimeout(() => target.focus({ preventScroll: true }), 350);
    }
  }

  function validate(form) {
    const service = getValue(form, 'service') || 'india-shopping';
    const required = ['name', 'email', 'phone', 'message'];
    required.push(service === 'student-care' ? 'destination_student_care' : 'destination_india_shopping');

    let firstInvalid = null;
    form.querySelectorAll('.ss-error').forEach((error) => { error.textContent = ''; });
    form.querySelectorAll('.is-invalid').forEach((field) => {
      field.classList.remove('is-invalid');
      field.removeAttribute('aria-invalid');
    });

    required.forEach((name) => {
      const field = form.querySelector('[name="' + name + '"]');
      if (!field || !visible(field.closest('[data-service-fields]')) && field.closest('[data-service-fields]')) return;
      let message = '';
      if (!field.value.trim()) message = 'This field is required.';
      if (!message && name === 'email' && !/^\S+@\S+\.\S+$/.test(field.value.trim())) message = 'Enter a valid email address.';
      if (!message && name === 'phone' && cleanPhone(field.value).length < 8) message = 'Enter a valid phone or WhatsApp number.';
      setFieldError(form, name, message);
      if (message && !firstInvalid) firstInvalid = field;
    });

    return firstInvalid;
  }

  function buildMessage(root, form) {
    const service = getValue(form, 'service') || 'india-shopping';
    const serviceLabel = service === 'student-care' ? 'Student Care Packages' : 'Shop in India -> Ship Worldwide';
    const intro = root.getAttribute('data-whatsapp-intro') || 'New shipping services lead from Prithvi Mart';
    const lines = [
      intro,
      '',
      'Service: ' + serviceLabel,
      'Name: ' + getValue(form, 'name'),
      'Email: ' + getValue(form, 'email'),
      'Phone / WhatsApp: ' + getValue(form, 'phone')
    ];

    if (service === 'student-care') {
      lines.push('Pickup city and postcode: ' + (getValue(form, 'pickup') || 'Not provided'));
      lines.push('Package contents: ' + (getValue(form, 'contents') || 'Not provided'));
      lines.push('Destination: ' + getValue(form, 'destination_student_care'));
    } else {
      lines.push('Order details: ' + (getValue(form, 'orders') || 'Not provided'));
      lines.push('Destination: ' + getValue(form, 'destination_india_shopping'));
    }

    lines.push('Notes: ' + getValue(form, 'message'));
    lines.push('Page: ' + window.location.href.split('#')[0]);
    return lines.join('\n');
  }

  function init(root) {
    const form = root.querySelector('[data-ss-form]');
    if (!form) return;

    const serviceField = form.querySelector('[name="service"]');
    const status = form.querySelector('[data-ss-status]');
    const params = new URLSearchParams(window.location.search);
    const initialService = params.get('service');
    if (initialService === 'student-care' || initialService === 'india-shopping') {
      updateService(root, initialService, window.location.hash === '#ss-book');
    } else {
      updateService(root, serviceField ? serviceField.value : 'india-shopping', false);
    }

    if (serviceField) {
      serviceField.addEventListener('change', () => updateService(root, serviceField.value, false));
    }

    root.querySelectorAll('[data-ss-book-service]').forEach((link) => {
      link.addEventListener('click', () => {
        updateService(root, link.getAttribute('data-ss-book-service'), true);
      });
    });

    form.querySelectorAll('input, textarea, select').forEach((field) => {
      field.addEventListener('input', () => setFieldError(form, field.name, ''));
      field.addEventListener('change', () => setFieldError(form, field.name, ''));
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const firstInvalid = validate(form);
      if (firstInvalid) {
        if (status) {
          status.hidden = false;
          status.textContent = 'Please complete the highlighted fields before opening WhatsApp.';
        }
        firstInvalid.focus({ preventScroll: true });
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (status) {
        status.hidden = true;
        status.textContent = '';
      }

      const number = cleanPhone(root.getAttribute('data-whatsapp-number')) || '12262413517';
      const message = encodeURIComponent(buildMessage(root, form));
      window.open('https://wa.me/' + number + '?text=' + message, '_blank', 'noopener');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'shipping_services_whatsapp_lead', service: getValue(form, 'service') });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-shipping-services]').forEach(init);
  });
})();